<div class="container mt-4">
    <h3>Offline</h3>
    <p>
        Sei attualmente <b>offline</b>. Puoi modificare le seguenti revisioni oppure caricarne manualmente una per continuare.
        LocalStorage size: {{localStorageSize}}
    </p>

    <table class="table table-bordered">
        <thead>
            <tr>
                <th scope="col">ID Assegnazione</th>
                <th scope="col">Denom. Ente</th>
                <th scope="col">Cod. fiscale</th>
                <th scope="col">Revisore</th>
                <th scope="col">Annualità</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let revisione of revisioniInLocalStorage; index as i">
                <td>{{revisione.idAssegnazione}}</td>
                <td>{{revisione.denomEnte}}</td>
                <td>{{revisione.codiceFiscale}}</td>
                <td>{{revisione.revisore}}</td>
                <td>{{revisione.anno1}} / {{revisione.anno2}}</td>
                <td>
                    <a [routerLink]="['/revisione53', 'dati-identificativi']" [queryParams]="{idRevisione: revisione.idAssegnazione}" [queryParamsHandling]="'merge'"
                       class="btn btn-primary">Apri</a>
                </td>
            </tr>
        </tbody>
    </table>

    <button
        (click)="fileInput.click()"
        class="btn"
        style="color:rgba(0, 85, 159, 1)">

        <i class="bi bi-file-earmark-arrow-up-fill"></i>
        Carica da PC
        <input #fileInput type="file" (change)="upload($event)" style="display:none;" accept=".backup" />
    </button>

</div>
